import styled from "styled-components";
import { SVGDocument, SVGMp3 } from "@/lib/svg";

// https://www.figma.com/file/16YSFRr06xdFYJFqNgvv41/Bormioli-Product-Design?node-id=897%3A56483
export const Title = styled.p`
  display: block;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-weight: 600;
  font-size: 1.25rem;
  line-height: 1.4;
  background-color: transparent !important;

  margin-left: 1rem;
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-left: 1.5rem;
  }
`;

export const Container = styled.a`
  display: block;
  text-decoration: none;
`;

export const Inner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  transition: all 0.1s ease-in;

  &:hover {
    cursor: pointer;
    box-shadow: ${({ theme }) => theme.shadows.panelShadow};
    ${Title} {
      color: ${({ theme }) => theme.colors.red};
    }
  }
`;

export const DocumentIcon = styled(SVGDocument as any)`
  width: 1em;

  margin-top: 1rem;
  margin-left: 1rem;
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-top: 1.5rem;
    margin-left: 1.5rem;
  }
`;

export const Mp3Icon = styled(SVGMp3 as any)`
  width: 1.35em;

  margin-left: 1rem;
  margin-top: 1rem;
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-left: 1.5rem;
    margin-top: 1.5rem;
  }
`;

export const LabelAndDescription = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 0.875rem; // 14px
  line-height: 1.5; // 160% // 22px

  margin-bottom: 1rem;
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-bottom: 1.5rem;
  }
`;

export const Label = styled.p`
  color: ${({ theme }) => theme.colors.darkMiddle};
  background-color: transparent !important;

  margin-left: 1rem;
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-left: 1.5rem;
  }
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.darkMiddle};
  background-color: transparent !important;
`;

export const Size = styled.p`
  color: ${({ theme }) => theme.colors.middleGrey};
  font-size: 0.875rem; // 14px
  line-height: 1.5; // 160% // 22px

  margin-left: 1rem;
  margin-bottom: 1rem;
  ${({ theme }) => theme.mediaQueries.laptop} {
    margin-left: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;
